// extracted by mini-css-extract-plugin
export var circle = "_ax-1";
export var exitConfirmationModal = "_ax-5";
export var iframe = "_ax-0";
export var offline = "_ax-3";
export var online = "_ax-2";
export var workstationSelectError = "_ax-4";